import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HeaderComponent } from '@app/core/layouts/header/header.component';
import { SharedModule } from '@app/shared/shared.module';
import {
    ButtonModule,
    CardModule,
    FooterModule,
    HeaderModule,
    InfoFieldsModule,
    InputModule,
    RadioModule
} from 'hig-ng-lib';
import { FooterComponent } from './footer/footer.component';
import { ClaimMenuComponent } from './header/claim-menu/claim-menu.component';

@NgModule({
    declarations: [HeaderComponent, FooterComponent, ClaimMenuComponent],
    imports: [
        CommonModule,
        HeaderModule,
        FooterModule,
        ButtonModule,
        InfoFieldsModule,
        InputModule,
        RadioModule,
        CardModule,
        SharedModule
    ],
    exports: [HeaderComponent, FooterComponent]
})
export class LayoutsModule {}
